const Blog = () => {
    return (<div>
        BLOG
    </div>)
}

export default Blog